import format from 'string-template';

import texts from './texts.json';

/**
 * Options presented when a coach edits a workout that is shared across programs/days from within
 * a program (copy-on-write decision).
 * - CREATE_NEW: Fork a private copy with the changes; re-point only the edited day.
 * - UPDATE_ALL: Edit the shared workout in place (affects every program/day referencing it).
 */
const SharedWorkoutEditType = {
  CREATE_NEW: 'CREATE_NEW',
  UPDATE_ALL: 'UPDATE_ALL',
};

const sharedWorkoutEditOptions = [
  {
    value: SharedWorkoutEditType.UPDATE_ALL,
    label: texts.updateAllOption,
  },
  {
    value: SharedWorkoutEditType.CREATE_NEW,
    label: texts.createNewOption,
  },
];

/**
 * Builds the body copy for the shared-workout modal, accurately reflecting where the workout is
 * used: other days in this program, other programs, or both.
 *
 * @param {{ otherProgramCount: number, sameProgramOtherDayCount: number }} usage
 * @returns {string}
 */
const buildSharedWorkoutMessage = (usage) => {
  const { otherProgramCount = 0, sameProgramOtherDayCount = 0 } = usage || {};
  const clauses = [];
  if (sameProgramOtherDayCount > 0) {
    clauses.push(format(texts.otherDays, { count: sameProgramOtherDayCount }));
  }
  if (otherProgramCount > 0) {
    clauses.push(format(texts.otherPrograms, { count: otherProgramCount }));
  }
  return format(texts.message, { usage: clauses.join(texts.and) });
};

export {
  SharedWorkoutEditType,
  sharedWorkoutEditOptions,
  buildSharedWorkoutMessage,
};
